import { FC } from "react";
import PopupSlider from "./components/PopupSlider/PopupSlider";
import { SliderTypeProps } from "./types";

const SliderType: FC<SliderTypeProps> = ({ ...props }) => (
  <PopupSlider {...props} />
);

export default SliderType;
